import React from 'react';

const HighSchool = () => {
  return (
    <div>
      <h1>高校生</h1>
      <p>ここでは、プログラミングやAI、Web開発の学習内容について紹介します。</p>
    </div>
  );
};

export default HighSchool;